import Joi from 'joi'

const ConfirmQuoteCancellationDialogValidation = Joi.object({
  quoteLostReasonId: Joi.string().empty('').when('$isQuote', { is: false, then: Joi.optional() }),
  cancellationReasonOrQuoteLostDetail: Joi.string().empty(''),
})

export { ConfirmQuoteCancellationDialogValidation }
